import { getLocale } from '../../common/util';
import { ElementClickEvent, PageViewEvent, TrackingEvent } from './types';
import { getLastLoggedInCustomerId } from '../../common/logging/utils';
import { getUtmCookieValues } from '../cookie/utm';
import { nuiCtx } from '../../common/initialization';
import { getDeviceId, getSessionId } from './utils';
import {
    TV_NIKE_ARCHIVE_DETAIL_PATH,
    TV_NIKE_HIGHLIGHTS_DETAIL_PATH,
    TV_NIKE_STREAM_DETAIL_PATH
} from '../../common/routing';

const getPosition = (string, subString, index) => {
    return string.split(subString, index).join(subString).length;
};
const matchSlicedPath = (path, string) => {
    return path.match(string.substring(0, string.indexOf(':')));
};

const getChannelForDwh = () => (nuiCtx.platform === 'mobile' ? 'Mobile' : 'Portal');
const getDevice = () => window.OPTIONS.deviceType;
const getPageName = () => {
    const path = window.location.pathname;
    if (
        matchSlicedPath(path, TV_NIKE_STREAM_DETAIL_PATH) ||
        matchSlicedPath(path, TV_NIKE_ARCHIVE_DETAIL_PATH) ||
        matchSlicedPath(path, TV_NIKE_HIGHLIGHTS_DETAIL_PATH)
    ) {
        const positionLastSlash = getPosition(TV_NIKE_STREAM_DETAIL_PATH, '/', 4);
        return path.substring(0, positionLastSlash);
    }
    return path;
};

export const getGeneralTrackingData = (): TrackingEvent => {
    return {
        contractId: String(getLastLoggedInCustomerId()),
        loggedIn: nuiCtx.user.isloggedIn,
        deviceId: getDeviceId(),
        sessionId: getSessionId(),
        deviceType: getDevice(),
        channel: getChannelForDwh(),
        resolution: window.outerWidth + 'x' + window.outerHeight, // viewport that shows the website with browser's bars
        pageLocation: window.location.href,
        pageReferrer: document.referrer,
        pageTitle: document.title,
        pageName: getPageName(),
        language: getLocale(),
        utm: getUtmCookieValues()
    };
};

export const getTackingPageViewData = (additionalPageViewData?: string): PageViewEvent => {
    return {
        additionalData: additionalPageViewData
    };
};

export function getClosestAttribute(event, attribute: string) {
    if (!event.target || !attribute) {
        return null;
    }

    return event.target.closest('[' + attribute + ']')?.getAttribute(attribute);
}

export const getTrackingClickData = (event): ElementClickEvent => {
    const eventText = event.target.innerText || event.target.innerHTML;

    return {
        elementDataAtid: getClosestAttribute(event, 'data-atid'),
        elementId: event.target.id,
        elementText: eventText.slice(0, 50),
        elementClassess: event.target.classList?.value,
        elementUrl: getClosestAttribute(event, 'href')
    };
};
